"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentWebhookIMSchema = exports.AssessmentWebhookSchema = void 0;
const zod_1 = require("zod");
exports.AssessmentWebhookSchema = zod_1.z.object({
    id: zod_1.z.string(),
    submissionId: zod_1.z.string(),
    formId: zod_1.z.string(),
    disclosureId: zod_1.z.string(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
exports.AssessmentWebhookIMSchema = exports.AssessmentWebhookSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
